import React from 'react';
import PropTypes from 'prop-types';
import { VolunteerFormView } from '../../components';

const propTypes = {
  gfyData: PropTypes.array
}

const defaultProps = {
  gfyData: []
}

class VolunteerPageView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showMore: false,
      page: 0,
      loading: false
    };
  }

  render() {
    return (
      <div className="main-content">
        <div id="page-not-found">
          <div className="container-fluid content">
            <div className="row">
              <div className="col-12 bg-fff-50 border-grey p-3 mb-5">
                <h2>Volunteer Opportunities</h2>
                <p className="note">
                  If you are a nature and wildlife lover who enjoys these cameras everyday, we have a few
                  volunteer opportunities for great team players. Please check an option and a member of our
                  team will respond as soon as possible.
                </p>
                <VolunteerFormView removeModal={() => {}} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}
VolunteerPageView.propTypes = propTypes;
VolunteerPageView.defaultProps = defaultProps;

export default VolunteerPageView;
